import { jsx as _jsx } from "react/jsx-runtime";
import ContentfulPage from "../../../ContentfulPage";
import { PAGE_IDS } from "@iscr/contentful/constants";
const BlogPostWrapper = ({ slug, contentTag = PAGE_IDS.BLOG_POST }) => {
    return _jsx(ContentfulPage, { contentTag: contentTag, identifier: slug, isStatic: false });
};
export default BlogPostWrapper;
